<div *ngIf="currentEnv == 'emvs'">
    <div class="page__content">
      <div class="content__inner">
        <div class="register-form">
          <div class="row">
            <div class="col-sm-12">
              <h5 id="solicitud-titulo">{{procedimiento.nombre}}
              </h5>
            </div>
          </div>
  
          <ul class="nav nav-tabs nav-stepper" id="myTab" role="tablist">
            <li class="nav-item">
              <a  [ngClass]="esNavegable('personales-tab')" class="active" id="personales-tab" data-toggle="tab" href="#personales" role="tab" 
                aria-controls="home" aria-selected="true" (click)="restauraPestaniaSeleccionada('personales-tab')">
                <span>{{ 'TRAMITE.TABS.APPLICANT_DATA' | translate }}</span>
              </a>
            </li>
            <li class="nav-item">
              <a [ngClass]="esNavegable('representacionReducida-tab')" id="representacionReducida-tab" data-toggle="tab" href="#representacionReducida" role="tab" 
                aria-controls="representacion" aria-selected="true" (click)="restauraPestaniaSeleccionada('representacionReducida-tab')" >Datos representante</a>
            </li>         
  
            <li class="nav-item">
              <a [ngClass]="esNavegable('instancia-tab')" id="instancia-tab" data-toggle="tab" href="#instancia" role="tab" 
                aria-controls="contact" aria-selected="false" (click)="restauraPestaniaSeleccionada('instancia-tab')">Expone/Solicita</a>
            </li>
  
            <li class="nav-item" >
              <a [ngClass]="esNavegable('politicas-tab')" id="politicas-tab" data-toggle="tab" href="#politicas" role="tab" 
                aria-controls="contact" aria-selected="false" (click)="restauraPestaniaSeleccionada('politicas-tab')">Política de privacidad</a>
            </li>
          </ul>
          <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-clip-rotate" [fullScreen] = "true" [name]="'tramite_instancia_general_spinner'">
            <p style="color: white" >{{mensajeSpinner}}</p>
          </ngx-spinner>
          <div class="tab-content" id="myTabContent">
  
            <div class="tab-pane fade show active" id="personales" role="tabpanel" aria-labelledby="personales-tab">
  
              
              <div >
  
                <h3 class="tabtitle">{{ 'TRAMITE.TITLES.PERSONAL_DATA_NOTIFICATIONS' | translate }}</h3>
                <div class="row mt-3">
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.N_DE_DOCUMENTO' | translate }}</label>
                    <input type="text" id="numero_documento" name="numero_documento"
                      [ngModel]="this.currentUser.numero_documento" class="form-control" disabled />
                  </div>
                  <div class="col-sm-4 spacing-box" *ngIf="this.currentUser.tipopersona.id == 1">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.APELLIDOS' | translate }}</label>
                    <input type="text" id="apellido" name="apellido"
                      [ngModel]="this.currentUser.apellido1 + ' ' +this.currentUser.apellido2" class="form-control"
                      disabled>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ (this.currentUser.tipopersona.id == 1 ? 'TRAMITE.FORM.LABEL.NOMBRE' : 'TRAMITE.FORM.LABEL.RAZON_SOCIAL') | translate }}</label>
                    <input type="text" id="nombre" name="nombre" [ngModel]="this.currentUser.nombre" class="form-control"
                      disabled />
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_VIA' | translate }}</label>
                    <input type="text" id="tipovia" name="tipovia"
                      [ngModel]="this.activeAddress.type_of_road.tipovia" class="form-control"
                      disabled>
                  </div>
                  <div class="col-sm-8 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.DIRECCION' | translate }}</label>
                    <input type="text" id="name_road" name="name_road"
                      [ngModel]="this.activeAddress.name_road + ' ' + this.activeAddress.number_road" class="form-control"
                      disabled>
                  </div>
  
                  <div *ngIf="activeAddress.block" class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PORTAL' | translate }}</label>
                    <input type="text" id="block" name="block"
                      [ngModel]="this.activeAddress.block" class="form-control"
                      disabled>
                  </div>
  
                  <div *ngIf="activeAddress.stairs" class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.ESCALERA' | translate }}</label>
                    <input type="text" id="stairs" name="stairs"
                      [ngModel]="this.activeAddress.stairs" class="form-control"
                      disabled>
                  </div>
  
                  <div *ngIf="activeAddress.floor" class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PLANTA' | translate }}</label>
                    <input type="text" id="floor" name="floor"
                      [ngModel]="this.activeAddress.floor" class="form-control"
                      disabled>
                  </div>
  
                  <div *ngIf="activeAddress.door" class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PUERTA' | translate }}</label>
                    <input type="text" id="door" name="door"
                      [ngModel]="this.activeAddress.door" class="form-control"
                      disabled>
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.CODIGO_POSTAL' | translate }}</label>
                    <input type="text" id="postal_code" name="postal_code" [ngModel]="this.activeAddress.postal_code"
                      class="form-control" disabled />
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PROVINCIA' | translate }}</label>
                    <input class="w-100 form-control" id="province" name="province"
                      [ngModel]="activeAddress.province.nombre" disabled />
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.MUNICIPIO' | translate }}</label>
                    <input class="w-100 form-control" id="nameMunicipality" name="nameMunicipality"
                      [ngModel]="municipioNombre" disabled />
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <div class="form-group">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO' | translate }}</label>
                      <input type="text" id="telefono" name="telefono" [ngModel]="this.currentUser.telefono"
                        class="form-control" disabled />
                    </div>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <div class="form-group">
                      <label class="tinyLabel">{{ 'PLACEHOLDER.EMAIL' | translate }}</label>
                      <input type="text" id="email" name="email" [ngModel]="this.currentUser.email" class="form-control"
                        disabled />
                    </div>
                  </div>
                  
                  <form [formGroup]="formTramite" (ngSubmit)="onSubmitTramite()" class="w-100" >
                    <div class="col-sm-12">
                      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                        <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                        <button  type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>                         
                        <button type="submit" class="btn btn-primary mt-2" id="siguiente1">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
  
  
            <div class="tab-pane fade" id="politicas" role="tabpanel"
              aria-labelledby="politicas-tab">
              <form [formGroup]="formPoliticas">
                <h3 class="tabtitle">Política de privacidad</h3>
                <!-- <p>{{lopd}}</p> -->
                <div [innerHTML]="lopd"></div>
                <div class="smallInfo pl-3">
                  <label class="form-check-label"><input class="form-check-input position-static" type="checkbox" formControlName="politicas" id="politicas"[value]=""/>
                   He leído y acepto las Políticas de privacidad</label>
                </div>
                <div class="col-sm-12">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button [disabled]="isSigning" type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button  [disabled]="isSigning" type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>                    
                    <!--<button [disabled]="isSigning" type="submit" (click)="onSubmitPoliticas()"
                      class="btn btn-primary mt-2">{{ 'TRAMITE.CONTENT.FINALIZAR' | translate }}</button>-->
                    <fieldset [disabled]="isSigning">
                      <boton-listado>                  
                      </boton-listado>
                    </fieldset>
                  </div>
                </div>
              </form>
            </div>
           
  
            <div class="tab-pane fade" id="representacionReducida" role="tabpanel" aria-labelledby="representacionReducida-tab">
              <h3 class="tabtitle">DATOS PERSONALES DEL REPRESENTANTE</h3>
              <form [formGroup]="formRepresentanteReducido" (ngSubmit)="onSubmitRepresentado()">
                <div class="row p-2 mt-4 mr-0 ml-0">
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.N_DE_DOCUMENTO' | translate }}</label>
                    <input type="text" formControlName="documento_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['documento_representado'].errors}"/>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.APELLIDOS' | translate }}</label>
                    <input type="text" formControlName="apellidos_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['apellidos_representado'].errors}">
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'PROCEDIMIENTO.EDIT.NAME' | translate }}</label>
                    <input type="text" formControlName="nombre_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['nombre_representado'].errors}"/>
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_VIA' | translate }}</label>
                    <select formControlName="tipo_via_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['tipo_via_representado'].errors}">
                      <option *ngFor="let vias of TVias" [value]="vias.id">
                          {{ vias.tipovianormalizado }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-8 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.DIRECCION' | translate }}</label>
                    <input type="text" formControlName="direccion_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['direccion_representado'].errors}">
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.N_DE_CALLE' | translate }}</label>
                    <input type="text" formControlName="numero_calle_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['numero_calle_representado'].errors}">
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PORTAL' | translate }}</label>
                    <input type="text" formControlName="portal_representado" class="form-control">
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.ESCALERA' | translate }}</label>
                    <input type="text" formControlName="escalera_representado" class="form-control">
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PLANTA' | translate }}</label>
                    <input type="text" formControlName="planta_representado" class="form-control">
                  </div>
                  <div class="col-sm-2 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PUERTA' | translate }}</label>
                    <input type="text" formControlName="puerta_representado" class="form-control">
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.CODIGO_POSTAL' | translate }}</label>
                    <input type="text" mask="9{5}" formControlName="cp_representado" class="form-control"
                      [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['cp_representado'].errors}">
                  </div>
                  <div class="col-sm-6 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.PROVINCIA' | translate }}</label>
                    <select formControlName="provincia_representado" class="form-control"
                      (change)="onChangeMunicipio($event)" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['provincia_representado'].errors}">
                      <option *ngFor="let prov of TProvincias" [value]="prov.id">
                        {{ prov.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-6 spacing-box">
                    <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.MUNICIPIO' | translate }}</label>
                    <select formControlName="municipio_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['municipio_representado'].errors}">
                      <option *ngFor="let loc of TMunicipios" [value]="loc.municipioPK['municipio_id']">
                        {{ loc.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <div class="form-group">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.CORREO_ELECTRONICO' | translate }}</label>
                      <input type="text" formControlName="email_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['email_representado'].errors}"/>
                    </div>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <div class="form-group">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO_1' | translate }}</label>
                      <input type="text" formControlName="telefono1_representado" class="form-control" [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['telefono1_representado'].errors}"/>
                    </div>
                  </div>
                  <div class="col-sm-4 spacing-box">
                    <div class="form-group">
                      <label class="tinyLabel">{{ 'TRAMITE.FORM.LABEL.TELEFONO_2' | translate }}</label>
                      <input type="text" formControlName="telefono2_representado" class="form-control"  [ngClass]="{'is-invalid': submitRepresentante && formRepresentanteReducido.controls['telefono2_representado'].errors}"/>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                      <button type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                      <button  [disabled]="uploadDocuments" type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button> 
                      <button [disabled]="uploadDocuments" type="submit" class="btn btn-primary m-right mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="tab-pane fade" id="instancia" role="tabpanel" aria-labelledby="instancia-tab">
              <form [formGroup]="formInstancia" (ngSubmit)="onSubmitInstancia()">
                <h3 class="w-100 tabtitle">Expone</h3>
                <textarea rows="4" class="w-100" formControlName="expone" [ngClass]="{'invalid-textarea': submitInstancia && this.formInstancia.controls['expone'].errors}"></textarea>
  
                <h3 class="w-100 tabtitle">Solicita</h3>
                <textarea rows="4" class="w-100" formControlName="solicita" [ngClass]="{'invalid-textarea': submitInstancia && this.formInstancia.controls['solicita'].errors}"></textarea>
  
                <h3 class="w-100 tabtitle">Archivos adjuntos</h3>
                <div class="col-sm-12">
                  <div class="col-sm-12 d-flex align-items-center">
                    <p class="col-sm-6 spacing-box">{{ 'TRAMITE.CONTENT.ADJUNTAR_DOCUMENTOS' | translate }}</p>
                    <div class="custom-file">
                      <input type="file"  accept="application/pdf" class="custom-file-input" id="customFileLang" (change)="handleUpload($event)">
                      <label class="custom-file-label" data-browse="Elegir" for="customFileLang">{{ 'TRAMITE.FORM.LABEL.SELECCIONAR_ARCHIVO' | translate }}</label>
                    </div>
                  </div>
                  <table class="table table-striped">
                    <tr>
                      <td class="tinyLabel">{{ 'TRAMITE.CONTENT.NOMBRE_DOCUMENTO' | translate }}</td>
                    </tr>
                    <tr *ngFor="let documento of this.mapDocumentos">
                      <td>{{documento['nameDocument'] }}</td>
                      <td><button (click)="removeFile(mapDocumentos.indexOf(documento))"
                          class="btn btn-danger">{{ 'TRAMITE.FILE.DELETE' | translate }}</button></td>
                    </tr>
                  </table>  
                </div>
                <div class="col-sm-12">
                  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button [disabled]="uploadDocuments" type="button" class="btn btn-danger mt-2 mr-2" (click)="deleteTramite()">{{ 'COMMON.BUTTON.CANCEL' | translate }}</button>
                    <button [disabled]="uploadDocuments" type="button" class="btn btn-primary mt-2 mr-2" (click)="volver()">{{ 'COMMON.BUTTON.BACK' | translate }}</button>                    
                    <button [disabled]="uploadDocuments" type="submit" class="btn btn-primary mt-2">{{ 'COMMON.BUTTON.NEXT' | translate }}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form id="firma" (submit)="resultchange($event)" class="">
      <input type="hidden" id="result" />
      <input type="hidden" id="error" />
      <input type="hidden" id="certifcado" />
    </form>
  
  </div>